/**
 * Site configuration selected at build time via REACT_APP_VARIANT.
 *
 * Build commands:
 *   REACT_APP_VARIANT=sk    → Slovak maturita  (default)
 *   REACT_APP_VARIANT=cz    → Czech maturita
 *   REACT_APP_VARIANT=monitor-sk → Slovak monitor exam
 *
 * In package.json you can add:
 *   "build:sk":         "REACT_APP_VARIANT=sk react-scripts build ..."
 *   "build:cz":         "REACT_APP_VARIANT=cz react-scripts build ..."
 *   "build:monitor-sk": "REACT_APP_VARIANT=monitor-sk react-scripts build ..."
 *
 * On Windows use cross-env:
 *   "build:cz": "cross-env REACT_APP_VARIANT=cz react-scripts build"
 */

import sk from './sk'
import cz from './cz'
import monitorSk from './monitor-sk'
import type { SiteConfig } from './types'

const configs: Record<string, SiteConfig> = { sk, cz, 'monitor-sk': monitorSk }

const variant = process.env.REACT_APP_VARIANT ?? 'sk'
const siteConfig = configs[variant] ?? sk

export default siteConfig

// ─── Derived payment helpers (mirrors old constants/payments.ts shape) ────────

export const analysisPeriods = siteConfig.payments.periods.map(({ id, title }) => ({ id, title }))

export const currentTestAnalysisPeriod = siteConfig.payments.currentPeriodId

export const currentTestAnalysisProduct = siteConfig.payments.currentProductId

export const metadataByProduct = Object.fromEntries(
  siteConfig.payments.periods.map((p) => [
    p.productId,
    { analysisPeriod: p.id, price: p.price },
  ])
)
